import { verticalOf } from "./verticals.js";
/** Today's price list, for every type that does not say otherwise. */
export const FULL_CATALOG_SHAPE = {
    onlyKind: null,
    tracksCost: true,
    hasCode: true,
    hasSaleUnit: true,
    imports: true,
    words: {
        item: "Ítem",
        items: "ítems",
        variant: "Variante",
        variants: "variantes",
        addVariant: "Agregar variante",
        section: "Sección",
        sections: "secciones",
        sectionExamples: "«Repuestos», «Mano de obra»",
        editSections: "Editar secciones",
        create: "Nuevo producto o servicio",
        search: "Busca en tus productos y servicios",
        theList: "los productos",
    },
};
/** A restaurant's menu: dishes, their price, their portions, their category. Nothing else. */
export const MENU_CATALOG_SHAPE = {
    onlyKind: "PRODUCT",
    tracksCost: false,
    hasCode: false,
    hasSaleUnit: false,
    imports: false,
    words: {
        item: "Plato",
        items: "platos",
        variant: "Porción",
        variants: "porciones",
        addVariant: "Agregar porción",
        section: "Categoría",
        sections: "categorías",
        sectionExamples: "«Entradas», «Bebidas»",
        editSections: "Editar categorías",
        create: "Nuevo plato o menú",
        search: "Busca un plato",
        theList: "el menú",
    },
};
/** A bakery's price list: the full one, without the code. */
export const BAKERY_CATALOG_SHAPE = { ...FULL_CATALOG_SHAPE, hasCode: false };
/** A car wash's price list: today's, where a variant is a size («Chico», «Mediano», «Grande»). */
const WASH_CATALOG_SHAPE = {
    ...FULL_CATALOG_SHAPE,
    words: { ...FULL_CATALOG_SHAPE.words, variant: "Tamaño", variants: "tamaños", addVariant: "Agregar tamaño" },
};
const CATALOG_SHAPES = {
    full: FULL_CATALOG_SHAPE,
    menu: MENU_CATALOG_SHAPE,
    bakery: BAKERY_CATALOG_SHAPE,
    wash: WASH_CATALOG_SHAPE,
};
export function catalogShapeFor(type) {
    return CATALOG_SHAPES[verticalOf(type).catalog];
}
export const DEFAULT_CATALOG_GUIDE = {
    name: "Producto o servicio",
    why: "¿Tiene varios precios?",
    variants: ["Pequeño", "Grande"],
};
export function catalogGuideFor(type) {
    return verticalOf(type).catalogGuide ?? DEFAULT_CATALOG_GUIDE;
}
/** The grey line under «Agregar variante» while an item has one price, the same on both clients. */
export function catalogGuideLine(guide) {
    return `${guide.why} Ej.: ${guide.variants.join(", ")}.`;
}
/** «secciones» → «Secciones»: a plural of `words` as a title. */
export function upperFirst(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
